import React from 'react';
import { BsThreeDots } from 'react-icons/bs';
import { Box, Flex, Icon, IconButton } from '@chakra-ui/react';
import PropTypes from 'prop-types';

import colors from '../../../../../styles/theme/foundation/colors';
import IconButtonMenu from '../../../../IconButtonMenu';

export const buttonBaseStyle = {
  background: 'inherit',
  borderBottom: '1px solid',
  borderTop: '1px solid',
  borderBottomColor: colors.greyScale['200'],
  borderTopColor: colors.greyScale['200'],
  color: colors.greyScale['900'],
  cursor: 'pointer',
  minHeight: '56px',
  padding: '1rem',
  width: '100%',
  _hover: { color: colors.primaryScale['600'], background: 'white' }
};

const RequirementMenuButton = ({
  title,
  description,
  leftIcon,
  isActive,
  isFavorite,
  onMenuButtonClick,
  onFavoriteButtonCLick,
  subMenu,
  id,
  blueprint,
  cypressId = undefined
}) => {
  const buttonStyles = isActive
    ? ({
      ...buttonBaseStyle,
      background: 'rgba(0, 140, 255, 0.1)',
      borderRightColor: colors.primaryScale['600'],
      color: colors.primaryScale['600'],
      padding: '0 1rem 0 1rem'
    })
    : { ...buttonBaseStyle, padding: '0 1rem 0 1rem' };

  return (
    <Box
      style={buttonStyles}
    >
      <Flex
        _hover={{ color: colors.primaryScale['600'] }}
        alignItems="center"
        data-cy={cypressId}
        justifyContent="space-between"
        onClick={onMenuButtonClick}
      >
        <Flex
          alignItems={description ? 'flex-start' : 'center'}
          justifyContent="flex-start"
          lineHeight="20px"
          mb={2}
          minHeight="calc(56px - 1rem)"
          mt={2}
        >
          <IconButton
            aria-label="favorite"
            icon={(
              <Icon
                as={leftIcon}
                color={isFavorite ? '#FFDD00' : colors.greyScale['300']}
                size="sm"
              />
            )}
            mr="14px"
            size="sm"
            variant="textPrimary"
            onClick={e => {
              e.stopPropagation();
              e.preventDefault();
              onFavoriteButtonCLick();
            }}
          />
          <Flex
            direction="column"
            lineHeight="20px"
            mt={description ? '0.4rem' : 'initial'}
            textAlign="left"
          >
            <Box overflowWrap="anywhere" textStyle="bodyMd500">
              {title}
            </Box>
            {description
            && (
            <Box
              color={isActive ? colors.primaryScale['600'] : colors.greyScale['500']}
              fontSize="12px"
              mt={1}
              overflowWrap="anywhere"
            >
              {description}
            </Box>
            )}
          </Flex>
        </Flex>
        {subMenu && (
          <Box mr={2}>
            <IconButtonMenu
              blueprint={blueprint}
              iconElement={<Icon as={BsThreeDots} width="20px" />}
              id={id}
              menuOptions={subMenu}
              size="xs"
              variant={isActive ? 'textPrimary' : 'textGrey'}
              width="auto"
            />
          </Box>
        )}
      </Flex>
    </Box>
  );
};

RequirementMenuButton.propTypes = {
  title: PropTypes.string,
  description: PropTypes.string,
  leftIcon: PropTypes.func,
  isActive: PropTypes.bool,
  isFavorite: PropTypes.number,
  onMenuButtonClick: PropTypes.func,
  onFavoriteButtonCLick: PropTypes.func,
  cypressIdFunction: PropTypes.string
};

export default RequirementMenuButton;
